import React, { useEffect, useState } from 'react'
import axios from '../../../services/Api'
import NumberFormat from 'react-number-format'

import './index.css';

import Card from 'react-bootstrap/Card'
import Button from 'react-bootstrap/Button'
import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'

import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'

export default function Plan({ history, location }) {
    const [plans, setPlans] = useState([]);

    useEffect(() => {
        getData();
    }, []);

    async function getData() {
        try {
            let response = await axios.get('/api/plans');
            setPlans(response.data);
            console.log(response.data);
        } catch (e) {
            console.log(e);
        }
    }

    return (
        <section className="Plan" id="plan">
            <h1 className="section-title centered">Planos</h1>

            <Tabs defaultActiveKey="mensal" id="plans-tab">
                <Tab eventKey="mensal" title="Mensal">
                    <Row>
                        {plans.map((plan) => makePlanCardsMonthly(plan))}
                    </Row>
                </Tab>
                <Tab eventKey="anual" title="Anual">
                    <Row>
                        {plans.map((plan) => makePlanCardsYearly(plan))}
                    </Row>
                </Tab>
            </Tabs>

            <div className="custom-plan red-background white-text section-padding">
                <Container>
                    <div className="text-center">
                        <h1>Nenhum dos planos se encaixa na sua necessidade?</h1>
                        <h4><a href="#">Clique aqui</a> e nós faremos um plano de acordo com a sua demanda!</h4>
                    </div>
                </Container>
            </div>
        </section>
    )

    /**
     * Render month plan cards
     * @param {*} plan 
     */
    function makePlanCardsMonthly(plan) {
        return (
            <>
                {
                    plan.cicle.map((cicle) => cicle.name === 'Mensal' ? (
                        <Col md={4} key={cicle.id}>
                            <Card className="text-center" >
                                <Card.Body>
                                    <Card.Title>{plan.name}</Card.Title>
                                    <h4>{cicle.name}</h4>

                                    <div className="options">
                                        {cicle.features.map((feature) => (
                                            <p>{feature.name}</p>
                                        ))}
                                    </div>

                                    <div className="container-value">
                                        <span className="prefix-value">R$</span>
                                        <span className="value"><NumberFormat value={cicle.value} displayType={'text'} decimalSeparator="," fixedDecimalScale={true} thousandSeparator="." decimalScale={2} prefix={''} /></span>
                                        <span className="cicle">{cicle.name === 'Mensal' ? '/mês' : '/ano'}</span>
                                    </div>

                                    <Button variant="primary" onClick={(e) => goToRegisterPage(plan, cicle)} >Selecionar plano</Button>
                                </Card.Body>
                            </Card>
                        </Col>
                    ) : null)
                }
            </>
        )

    }


    /**
     * Render yearly plan cards
     * @param {*} plan 
     */
    function makePlanCardsYearly(plan) {
        return (
            <>
                {
                    plan.cicle.map((cicle) => cicle.name !== 'Mensal' ? (
                        <Col md={4} key={cicle.id}>
                            <Card className="text-center" >
                                <Card.Body>
                                    <Card.Title>{plan.name}</Card.Title>
                                    <h4>{cicle.name}</h4>

                                    <div className="options">
                                        {cicle.features.map((feature) => (
                                            <p>{feature.name}</p>
                                        ))}
                                    </div>

                                    <div className="container-value">
                                        <span className="prefix-value">R$</span>
                                        <span className="value"><NumberFormat value={cicle.value} displayType={'text'} decimalSeparator="," fixedDecimalScale={true} thousandSeparator="." decimalScale={2} prefix={''} /></span>
                                        <span className="cicle">{cicle.name === 'Mensal' ? '/mês' : '/ano'}</span>
                                    </div>

                                    <Button variant="primary" onClick={(e) => goToRegisterPage(plan, cicle)}>Selecionar plano</Button>
                                </Card.Body>
                            </Card>
                        </Col>
                    ) : null)
                }
            </>
        )

    }

    function goToRegisterPage(plan, cicle) {
        history.push(`/register?plan_id=${plan._id}&cicle_id=${cicle.id}`);
    }

}